import { useMemo } from "react";
import { MIN_PROJECT_DATE } from "@/constants";

export const useYearRange = (
  startYearOffset = 0,
  endYearOffset = 0,
): number[] =>
  useMemo(() => {
    const minYear = MIN_PROJECT_DATE.getFullYear();
    const currentYear = new Date().getFullYear();
    const start =
      startYearOffset > 0
        ? Math.max(minYear, currentYear - startYearOffset)
        : currentYear;
    const end = currentYear + endYearOffset;
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
  }, [startYearOffset, endYearOffset]);
